// extracted by mini-css-extract-plugin
module.exports = {"priceCardContent":"styles_priceCardContent__3Ha6y","selected":"styles_selected__2vGN-"};